import { useAccount } from '../account';
import { useOrganizations } from './useOrganizations';
import { isAccountingFirmOrganization } from './utils';

export const useIsAccountingFirm = () => {
  const { data: organizations = [] } = useOrganizations();
  const { data: account } = useAccount({ id: 'me' });

  return organizations.some(
    (organization) =>
      organization.id === account?.organizationId && organization && isAccountingFirmOrganization(organization)
  );
};
